export const MIN_COUNT_TO_SHOW_BENEFITS = 1;
export const MAX_COUNT_TO_SHOW_BENEFITS = 2;
